import {useMemo} from 'react';

import {PANEL_BANK_HIDDEN_SECTION_NAME} from '../../util/panelbankTypes';
import {keyExistsInQueryString} from '../../util/query-string';
import {usePanelBankConfigWithRefs} from './hooks/usePanelBankConfigWithRefs';
import {SectionWithRef} from './types';
import {useIsSectionVisible} from './useIsSectionVisible';

export const useWorkspaceSections = () => {
  // This is our source of truth since it's what usePanelBankSectionList uses to filter on
  const panelBankConfigWithRefs = usePanelBankConfigWithRefs();

  const allSections: SectionWithRef[] = useMemo(() => {
    const panelBankSections = panelBankConfigWithRefs.sections;

    // for dev debugging purposes, we should show the "Hidden panels" section
    // if the proper query string is set. otherwise, hide it from user
    if (keyExistsInQueryString('SHOW_HIDDEN_SECTION')) {
      return panelBankSections;
    }

    if (panelBankSections.length === 0) {
      return [];
    }

    const lastSection = panelBankSections[panelBankSections.length - 1];
    if (lastSection.name === PANEL_BANK_HIDDEN_SECTION_NAME) {
      // Return the sections without the hidden section
      return panelBankSections.slice(0, -1);
    }

    return panelBankSections;
  }, [panelBankConfigWithRefs.sections]);

  const getIsSectionVisible = useIsSectionVisible();

  const visibleSections = useMemo(() => {
    return allSections.filter(section => getIsSectionVisible(section));
  }, [allSections, getIsSectionVisible]);

  return visibleSections;
};
